/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Logo_Url_HintInputs */

const cs_settings_office_logo_url_hint = /** @type {(inputs: Settings_Office_Logo_Url_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volitelná vzdálená adresa. Preferujte nahrání souboru níže.`)
};

const en_settings_office_logo_url_hint = /** @type {(inputs: Settings_Office_Logo_Url_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional remote URL. Prefer uploading a file below.`)
};

/**
* | output |
* | --- |
* | "Optional remote URL. Prefer uploading a file below." |
*
* @param {Settings_Office_Logo_Url_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_logo_url_hint = /** @type {((inputs?: Settings_Office_Logo_Url_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Logo_Url_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_logo_url_hint(inputs)
	return cs_settings_office_logo_url_hint(inputs)
});